<template>
    <div>
        <div class="form-container mr-auto ml-auto mt-3" v-if="field.helpDescription !== null">
            <v-alert type="info" :color="primaryColor" class="mt-5 mb-5 mr-auto ml-auto" border="right" colored-border>
                {{ field.helpDescription }}
            </v-alert>
        </div>

        <div class="form-container mr-auto ml-auto mt-3" v-if="!hasMediaShown">
            <v-alert type="warning" class="mt-5 mb-5 mr-auto ml-auto" border="right" colored-border>
                Nous n'avons aucune photo vous concernant.
            </v-alert>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <v-alert type="info" :color="primaryColor" class="mt-5 mb-5 mr-auto ml-auto" border="right" colored-border>
                <div>
                    Il est obligatoire de renseigner le <b>copyright</b> avec vos photos. En l'absence de copyright nous
                    ne pourrons pas les diffuser.
                </div>

                <div>Format : jpeg, png. Taille MINI de 1920 pixels sur le grand côté dans la limite de 10 Mo.</div>

                <div>
                    <v-btn text :color="primaryColor" class="text-none info-btn" @click="infoCopyright = true">
                        Qu'est-ce qu'un copyright ?
                    </v-btn>
                </div>
            </v-alert>

            <div class="mt-5" v-if="provider.medias.length">
                <div class="tabulation-title mb-2">
                    <h5 class="d-flex" style="font-size: 22px">
                        <div class="mr-2">
                            Image principale
                        </div>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on">help</v-icon>
                            </template>
                            <div>Si nous devions communiquer seulement une photo de votre activité, ce serait celle-ci
                            </div>
                        </v-tooltip>
                    </h5>
                </div>

                <div class="medias-box ml-2">
                    <media-card :field="field" :media="provider.medias[0]" :index="0"></media-card>
                </div>
            </div>

            <div class="mt-5">
                <div class="tabulation-title mb-2" v-if="provider.medias.length">
                    <h5 style="font-size: 22px">
                        Autres images
                    </h5>
                </div>

                <draggable v-model="provider.medias"
                           class="d-flex justify-start medias-box flex-wrap"
                           tag="tbody"
                           handle=".drag-handle"
                           :scroll-sensitivity="200"
                           :force-fallback="true"
                           :options="{
                                animation: 200,
                                ghostClass: 'sortable-ghost',
                                chosenClass: 'sortable-chosen'
                           }"
                >
                    <div v-for="(media, index) in provider.medias">
                        <div v-if="index !== 0" class="d-flex">
                            <v-icon class="drag-handle page__grab-icon" color="gray">mdi-drag</v-icon>

                            <media-card
                              :field="field"
                              :index="index"
                              :media="media"></media-card>
                        </div>
                    </div>
                </draggable>

                <media-upload class="ml-5"></media-upload>

            </div>
        </div>

        <v-dialog v-model="infoCopyright" max-width="700px" content-class="pro-dialog">
            <v-card :style="'font-family:' + fontFamily">
                <v-card-title>
                    <h2 style="font-size: 20px !important;" class="headline-title">
                        À propos du droit d'auteur
                    </h2>
                </v-card-title>
                <v-card-text>
                    <h3 class="mt-2 headline-title" style="font-size: 14px">Qu'est-ce que le copyright ?</h3>

                    <div>
                        Le copyright est un libellé qui désigne l'identité du titulaire des droits de la photo
                        (personne physique ou personne morale). Il atteste que l'auteur est d'accord que vous diffusiez
                        ses photos.
                    </div>

                    <h3 class="mt-4 headline-title" style="font-size: 14px">Connaissez-vous l'auteur des photos ?</h3>

                    <div>
                        Si oui, et que celui-ci vous a octroyé les droits d'utilisation de la photo, alors vous pouvez
                        indiquer son nom en tant que copyright. Sinon il est préférable de ne pas diffuser la photo
                        (et de la retirer de ce formulaire).
                    </div>

                    <h3 class="mt-4 headline-title" style="font-size: 14px">Pourquoi est-ce important de saisir un
                        copyright ?</h3>

                    <div>
                        Sans copyright, l'auteur de la photo peut se retourner contre nous et réclamer des réparations
                        pour diffusion de la photo sans autorisation.
                        Pour éviter cette situation, nous ne diffusons pas de photos sans copyright.
                    </div>

                    <v-spacer></v-spacer>

                    <div class="text-center mt-5 w-100">
                        <v-btn class="text-none" color="success" outlined @click="infoCopyright = false">
                            J'ai compris
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <media-full-screen-modal v-if="mediaFullScreenDialog"></media-full-screen-modal>
    </div>
</template>

<script>
import { mapState } from "vuex"
import draggable from "vuedraggable"
import draggableMixin from "@/mixins/draggableMixin"

import MediaUpload from "./MediaUpload.vue"
import MediaCard from "./MediaCard.vue"
import MediaFullScreenModal from "../../modals/MediaFullScreenModal.vue"

export default {
    name: "FormMedia",
    components: { MediaFullScreenModal, MediaCard, MediaUpload, draggable },
    props: ["field"],
    mixins: [draggableMixin],
    data() {
        return {
            infoCopyright: false,
        }
    },
    computed: {
        ...mapState("webFormStyle", ["primaryColor", "fontFamily"]),
        ...mapState("web_form", ["provider", "mediaFullScreenDialog"]),
        hasMediaShown() {
            let medias = this.provider.medias.filter(media => !media.is_404)

            return medias !== undefined && medias !== null && medias.length > 0
        },
    },
}
</script>